<!--
 * 作者: zhengyb 
 * 创建日期: 2021-05-13 16:49:40 
 * 最后修改人: zhengyb 
 * 最后修改时间: 2021-05-13 16:49:40 
 * 描述: 
 -->
<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.scaleGroup.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.scaleGroup.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.scaleGroup.delete')}}</el-button>
                    <el-button type="success" icon="el-icon-tickets" @click="handleShow">{{$t('pages.scaleGroup.viewDict')}}</el-button>
                </div>
                <div class="handle-headright">
                    <el-select v-model="query.percentType" @change="getData()" :placeholder="$t('pages.scaleGroup.selectPh')" class="handle-select mr10">
                        <el-option :label="$t('pages.scaleGroup.all')" value></el-option>
                        <el-option key="1" :label="$t('pages.scaleGroup.percent')" value="1"></el-option>
                        <el-option key="2" :label="$t('pages.scaleGroup.ratio')" value="2"></el-option>
                    </el-select>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.scaleGroup.search')}}</el-button>
                </div>
            </div>
            <el-table :data="ScaleGroups" border class="table" ref="multipleTable" :element-loading-text="$t('pages.scaleGroup.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.scaleGroup.index')"></el-table-column>
                <el-table-column sortable prop="name" :label="$t('pages.scaleGroup.groupName')"></el-table-column>
                <el-table-column prop="totalSpeed" :label="$t('pages.scaleGroup.totalFlow')"></el-table-column>
                <el-table-column prop="percentType" :label="$t('pages.scaleGroup.percentType')">
                    <template slot-scope="scope">{{ scope.row.percentType | percenttypeFormat }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.scaleGroup.enabled')">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enabledFt" @change="changeUse(scope.row)" />
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="enabled" label="是否使用">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enabled === '1' ? 'primary' : 'danger'" disable-transitions>{{
                            scope.row.enabled | usertypeFormat
                        }}</el-tag>
                    </template>
                </el-table-column>-->
                <!-- <el-table-column prop="modifyUserId" label="操作人"></el-table-column> -->
                <el-table-column sortable prop="modifyDate" :label="$t('pages.scaleGroup.modifyTime')">
                    <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.scaleGroup.operation')" width="110" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.scaleGroup.edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="60%" :close-on-click-modal="false">
            <el-form ref="ScaleGroup" :model="ScaleGroup" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.scaleGroup.groupName')" prop="name">
                            <el-input v-model="ScaleGroup.name"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.scaleGroup.totalFlow')" prop="totalSpeed">
                            <el-input-number v-model="ScaleGroup.totalSpeed" :min="0" class="size-full" @blur="setNum"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.scaleGroup.percentType')">
                            <el-select v-model="ScaleGroup.percentType" class="size-full">
                                <el-option key="1" :label="$t('pages.scaleGroup.percent')" value="1"></el-option>
                                <el-option key="2" :label="$t('pages.scaleGroup.ratio')" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.scaleGroup.use')" prop="enabledFt">
                            <el-switch v-model="ScaleGroup.enabledFt"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" style="margin-bottom: 10px">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" class="handle-add" @click="addItem">{{$t('pages.scaleGroup.add')}}</el-button>
                        <el-button type="danger" icon="el-icon-delete" class="handle-del mr10" @click="delitem">{{$t('pages.scaleGroup.delete')}}</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-table :data="ScaleGroupItems" border class="table" ref="multipleTable" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="55" align="center"></el-table-column>
                            <el-table-column type="index" width="50" :label="$t('pages.scaleGroup.index')"></el-table-column>
                            <el-table-column sortable prop="balanceName" :label="$t('pages.scaleGroup.feederName')"></el-table-column>
                            <el-table-column prop="displayName" :label="$t('pages.scaleGroup.materialName')" align="center">
                                <template slot-scope="scope">
                                    <el-input size="small" v-model="scope.row.displayName" autocomplete="off"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="percent" :label="$t('pages.scaleGroup.ratioCol')" align="center">
                                <template slot-scope="scope">
                                    <el-input size="small" v-model="scope.row.percent" autocomplete="off" oninput="value=value.replace(/[^0-9.]/g,'')" @change="setNum(scope.row, scope.$index)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="setNum" :label="$t('pages.scaleGroup.setFlow')"></el-table-column>

                            <el-table-column :label="$t('pages.scaleGroup.enabled')">
                                <template slot-scope="scope">
                                    <el-switch v-model="scope.row.enabledFt" @change="changeEnabled(scope.row)" />
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.scaleGroup.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('ScaleGroup')">{{$t('pages.scaleGroup.confirm')}}</el-button>
            </span>
        </el-dialog>

        <!-- 查看弹出框 -->
        <el-dialog :title="$t('pages.scaleGroup.viewDictTitle')" :visible.sync="viewVisible" width="50%" :close-on-click-modal="false">
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="24" style="margin-bottom: 10px">
                        <el-input v-model="searchName" class="size-halffull" :placeholder="$t('pages.scaleGroup.searchPh')"></el-input>
                        <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleShow">{{$t('pages.scaleGroup.search')}}</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-table :data="ScaleGroupName" border class="table" ref="multipleTable" v-loading="loading" header-cell-class-name="table-header">
                            <el-table-column type="index" width="50" :label="$t('pages.scaleGroup.index')"></el-table-column>
                            <el-table-column sortable prop="name" :label="$t('pages.scaleGroup.groupName')"></el-table-column>
                            <el-table-column prop="bName" :label="$t('pages.scaleGroup.deviceName')"></el-table-column>
                            <!-- <el-table-column prop="displayName" label="物料名"></el-table-column> -->
                            <el-table-column :label="$t('pages.scaleGroup.materialName')">
                                <template slot-scope="scope">
                                    <el-button type="text" style="color: #606266; font-size: 15px; padding-top: 0px; padding-bottom: 8px">{{ scope.row.displayName }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="enabled" :label="$t('pages.scaleGroup.enabled')">
                                <template slot-scope="scope">
                                    <el-tag :type="scope.row.enabled === 1 ? 'primary' : 'danger'" disable-transitions>
                                        {{
                                        scope.row.enabled | usertypeFormat
                                        }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="viewVisible = false">{{$t('pages.scaleGroup.close')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="headTitleItem" :visible.sync="editVisibleItem" width="40%" :close-on-click-modal="false">
            <el-form label-width="90px">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="给料机名" prop="checkedBalances">
                            <el-select multiple v-model="checkItems" placeholder="请选择" class="size-full">
                                <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisibleItem = false">取 消</el-button>
                <el-button type="primary" @click="saveEditItem('ScaleGroupItem')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { SortField } from '../../utils/helper';
export default {
    name: 'ScaleGroup',
    data: function () {
        return {
            balanceArr: [],
            ScaleGroupName: [],
            headTitle: '',
            headTitleItem: '',
            viewVisible: false,
            isadd: false,
            isaddItem: false,
            ScaleGroup: {},
            ScaleGroupItem: {},
            checkItems: [],
            editVisible: false,
            editVisibleItem: false,
            ScaleGroups: [],
            ScaleGroupItems: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            query: {
                percentType: '',
                PageIndex: 1,
                PageSize: 15
            },
            searchName: '',
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入组名',
                        trigger: 'blur'
                    }
                ],
                percentType: [
                    {
                        required: true,
                        message: '请选择占比方式',
                        trigger: 'blur'
                    }
                ],
                percent: [
                    {
                        required: true,
                        message: '请输入比例',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        percenttypeFormat(percentType) {
            var percentTypeName = '';
            if (percentType == '1') {
                percentTypeName = '百分制';
            } else {
                percentTypeName = '比例制';
            }
            return percentTypeName;
        },
        usertypeFormat(UserType) {
            var usertypeName = '';
            if (UserType == '1') {
                usertypeName = '启用';
            } else {
                usertypeName = '停用';
            }
            return usertypeName;
        }
    },
    created() {
        this.getData();
        this.getBalance('');
    },
    methods: {
        saveEdit() {
            this.$refs['ScaleGroup'].validate((valid) => {
                if (valid) {
                    var items = this.ScaleGroupItems;
                    var filterItems = items.filter((t) => t.enabled == 1);
                    var newItems = [];
                    if (items.length > 0 && filterItems.length > 0) {
                        for (let i = 0; i < items.length; i++) {
                            var item = items[i];
                            if (item.displayName == '') {
                                this.$notify.warning(item.balanceName + '的物料名称不能为空');
                                return;
                            }
                            if (item.percent == '') {
                                this.$notify.warning(item.balanceName + '的比例不能为空');
                                return;
                            }
                        }
                        var sum = filterItems.map((item) => parseInt(item.percent)).reduce((total, num) => total + num);

                        if (sum != 100 && this.ScaleGroup.percentType == '1') {
                            this.$notify.error('占比方式是百分制，并且启用的皮带秤之和不是100%');
                            return;
                        }
                        for (let i = 0; i < this.ScaleGroupItems.length; i++) {
                            let item = this.ScaleGroupItems[i];
                            item.percent = parseInt(item.percent);
                            newItems.push(item);
                        }
                    } else {
                        if (items.length > 0) {
                            newItems = items;
                        }
                    }
                    this.ScaleGroup.enabled = this.ScaleGroup.enabledFt ? '1' : '0';
                    this.$zybhttp
                        .post('ScaleGroup/ScaleGroupAddNew', { ScaleGroup: this.ScaleGroup, sitems: newItems })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(res.data.msg);
                                this.getData();
                                this.editVisible = false;
                                this.ScaleGroup = {};
                            } else {
                                this.$notify.error('添加失败');
                            }
                        })
                        .catch((err) => this.$notify.error('网络异常！添加失败'));
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveEditItem() {
            var itemIds = this.checkItems;
            var nData = new Array();
            var oldData = JSON.parse(JSON.stringify(this.ScaleGroupItems));
            for (var i = 0; i < itemIds.length; i++) {
                var nobj = oldData.filter((x) => x.balanceId == itemIds[i]);
                if (nobj.length > 0) {
                    nData.push(nobj[0]);
                } else {
                    var balanceName = this.balanceArr.filter((x) => x.id == itemIds[i])[0].name;
                    nData.push({
                        id: 0,
                        balanceId: itemIds[i],
                        balanceName: balanceName,
                        displayName: '',
                        enabled: 1,
                        enabledFt: true,
                        percent: '',
                        //scaleGroupId: '',
                        setNum: ''
                    });
                }
            }
            this.isaddItem = false;
            // this.isadd = false;
            this.editVisibleItem = false;
            this.ScaleGroupItem = {};
            this.ScaleGroupItems = nData;
        },
        changeUse(row) {
            row.enabled = row.enabledFt ? '1' : '0';
            //this.$notify.error(JSON.stringify(row));
            this.$zybhttp
                .post('ScaleGroup/ScaleGroupUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getData();
                    } else {
                        this.$notify.error('修改失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeEnabled(row) {
            row.enabled = row.enabledFt ? 1 : 0;
            this.setNum(row, 0);
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('ScaleGroup/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.enabledFt = x.enabled == '1';
                            return x;
                        }, []);
                        this.ScaleGroups = newdata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getBalance() {
            var scaleGroupId = 0;
            if (this.ScaleGroup != undefined) {
                scaleGroupId = this.ScaleGroup.id;
            }
            this.$zybhttp
                .get('Balance/GetBalance', {
                    //params: { balanceType: '2' }
                    params: { balanceType: '2', scaleItemFilter: 'yes', scaleGroup: scaleGroupId }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.balanceArr = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！11'));
        },
        getDataItems() {
            this.$zybhttp
                .get('ScaleGroupItem/GetList', {
                    params: { ScaleGroupId: this.ScaleGroup.id }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        if (d.length > 0) {
                            var newdata = d.sort(SortField('Id', 'desc'));
                            var percentType = this.ScaleGroup.percentType;
                            var totalSpeed = this.ScaleGroup.totalSpeed;
                            var sum = newdata.map((item) => parseInt(item.percent)).reduce((total, num) => total + num);
                            for (var i = 0; i < newdata.length; i++) {
                                if (percentType == '1') {
                                    newdata[i].setNum = ((totalSpeed * newdata[i].percent) / 100).toFixed(2);
                                } else {
                                    newdata[i].setNum = ((totalSpeed * newdata[i].percent) / sum).toFixed(2);
                                }
                            }
                            newdata = newdata.map((x) => {
                                x.enabledFt = x.enabled == 1;
                                return x;
                            }, []);
                            this.ScaleGroupItems = newdata;
                        } else {
                            this.ScaleGroupItems = [];
                        }
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getScaleGroupBy() {
            this.$zybhttp
                .get('ScaleGroup/BalanceFromScale', {
                    params: { search: this.searchName }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        this.ScaleGroupName = newdata;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        handleEdit(id, row) {
            this.ScaleGroup = JSON.parse(JSON.stringify(row));
            this.ScaleGroup.id = id;
            this.editVisible = true;
            this.isadd = false;
            this.ScaleGroup.enabledFt = this.ScaleGroup.enabled == '1';
            this.headTitle = this.$t('pages.scaleGroup.editTitle');
            this.getDataItems();
        },
        dbSelected(row) {
            this.ScaleGroup = JSON.parse(JSON.stringify(row));
            this.ScaleGroup.id = row.id;
            this.editVisible = true;
            this.isadd = false;
            this.ScaleGroup.enabledFt = this.ScaleGroup.enabled == '1';
            this.headTitleItem = this.$t('pages.scaleGroup.editTitle');
            this.getDataItems();
            // console.log(row);
        },
        handleShow() {
            this.viewVisible = true;
            this.getScaleGroupBy();
        },
        handleAdd() {
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.ScaleGroup = {};
            this.isadd = true;
            let date = new Date();
            // this.ScaleGroup.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.ScaleGroup.totalSpeed = 0;
            this.ScaleGroup.createUserId = userinfo.loginId;
            this.ScaleGroup.modifyUserId = userinfo.loginId;
            this.ScaleGroup.percentType = '1';
            this.ScaleGroup.enabledFt = true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.scaleGroup.addTitle');
            this.ScaleGroupItems = [];
        },
        addItem() {
            this.$refs['ScaleGroup'].validate((valid) => {
                if (valid) {
                    this.getBalance('');

                    var d = this.ScaleGroupItems;
                    var arr = new Array();
                    for (var i = 0; i < d.length; i++) {
                        arr.push(parseInt(d[i].balanceId));
                    }
                    this.checkItems = arr;

                    this.isaddItem = true;
                    this.editVisibleItem = true;
                    this.headTitleItem = '新增秤组明细信息';
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delitem() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].balanceName + ',';
                strValue += this.multipleSelection[i].balanceId + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.scaleGroup.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.scaleGroup.confirmDelete'), this.$t('pages.scaleGroup.tip'), {
                type: 'warning'
            })
                .then(() => {
                    var ids = strValue.substring(0, strValue.length - 1).split(',');

                    var condition = '';
                    for (var j = 0; j < ids.length; j++) {
                        condition += 'e.balanceId!=' + ids[j] + ' &&';
                    }
                    var data = this.ScaleGroupItems;
                    data = data.filter(function (e) {
                        return eval(condition.substring(0, condition.length - 2));
                    });
                    this.ScaleGroupItems = data;
                    this.setNum();
                })
                .catch(() => {});
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ',';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.scaleGroup.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.scaleGroup.confirmDeleteChild'), this.$t('pages.scaleGroup.tip'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('Account/UserDel?ids=1')
                        .get('ScaleGroup/ScaleGroupDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(`删除了${str}`);
                                this.getData();
                            } else {
                                this.$notify.error('删除失败');
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.scaleGroup.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        setNum(row, index) {
            var newdata = this.ScaleGroupItems;
            if (newdata.length > 0) {
                var totalSpeed = this.ScaleGroup.totalSpeed;
                var percentType = this.ScaleGroup.percentType;
                if (newdata.constructor === Array) {
                    var esum = newdata.filter((t) => t.enabled == 1);
                    if (esum.length > 0) {
                        var sum = esum.map((item) => parseInt(item.percent)).reduce((total, num) => total + num);
                        for (var i = 0; i < newdata.length; i++) {
                            if (percentType == '1') {
                                newdata[i].setNum = ((totalSpeed * newdata[i].percent) / 100).toFixed(2);
                            } else {
                                if (newdata[i].enabled == 1) {
                                    newdata[i].setNum = ((totalSpeed * newdata[i].percent) / sum).toFixed(2);
                                }
                            }
                        }
                        this.ScaleGroupItems = newdata;
                    } else {
                        this.ScaleGroupItems = [this.ScaleGroupItems[0]];
                    }
                } else {
                    newdata.setNum = totalSpeed.toFixed(2);
                    this.ScaleGroupItems = [newdata];
                }
            }
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
.size-halffull {
    width: 40%;
}
</style>
